var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecisionMaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 82,
    viewBox: "0 0 132 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_7520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1318 45.042H14.182V80.2874H38.1318V45.042Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5136 36.4297H48.5638V80.2876H72.5136V36.4297Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42 7.78711H82.47V80.2819H106.42V7.78711Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29346 79.5591L2.83784 78.2781L26.0744 51.7858L43.0761 67.1669L60.592 44.1875L75.5946 59.9228L83.9354 45.4005L85.6142 46.3709L75.9828 63.1445L60.757 47.1715L43.3381 70.0248L26.2345 54.5467L4.29346 79.5591Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.582 81.8007H2.32352C1.93746 81.8007 1.56722 81.6473 1.29424 81.3743C1.02126 81.1014 0.867897 80.7311 0.867897 80.3451V1.85796C0.867897 1.47191 1.02126 1.10167 1.29424 0.828684C1.56722 0.555702 1.93746 0.402344 2.32352 0.402344C2.70957 0.402344 3.07981 0.555702 3.3528 0.828684C3.62578 1.10167 3.77914 1.47191 3.77914 1.85796V78.8894H112.582C112.968 78.8894 113.338 79.0428 113.611 79.3158C113.884 79.5888 114.038 79.959 114.038 80.3451C114.038 80.7311 113.884 81.1014 113.611 81.3743C113.338 81.6473 112.968 81.8007 112.582 81.8007Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.593 38.0335L105.045 42.123L112.821 46.9666L115.368 42.8771L107.593 38.0335Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M107.593 38.0335L105.045 42.123L112.821 46.9666L115.368 42.8771L107.593 38.0335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2945 49.326C103.54 49.326 111.034 41.8314 111.034 32.5863C111.034 23.3413 103.54 15.8467 94.2945 15.8467C85.0495 15.8467 77.5549 23.3413 77.5549 32.5863C77.5549 41.8314 85.0495 49.326 94.2945 49.326Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2945 44.4204C100.83 44.4204 106.129 39.122 106.129 32.5862C106.129 26.0503 100.83 20.752 94.2945 20.752C87.7587 20.752 82.4603 26.0503 82.4603 32.5862C82.4603 39.122 87.7587 44.4204 94.2945 44.4204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.656 42.4869L111.691 45.6416C110.967 46.8039 111.322 48.333 112.484 49.057L124.654 56.638C125.816 57.362 127.345 57.0067 128.069 55.8444L130.035 52.6897C130.759 51.5275 130.403 49.9983 129.241 49.2743L117.071 41.6934C115.909 40.9694 114.38 41.3246 113.656 42.4869Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.113 31.4268L97.8268 37.7684L98.1277 26.4971L88.113 31.4268Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.359 33.5469L86.0509 41.0967C86.9698 42.0513 88.0745 42.8076 89.2969 43.3189L94.377 35.5265L91.359 33.5469Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1763 57.6962C28.2638 57.6962 29.9561 56.004 29.9561 53.9165C29.9561 51.829 28.2638 50.1367 26.1763 50.1367C24.0888 50.1367 22.3965 51.829 22.3965 53.9165C22.3965 56.004 24.0888 57.6962 26.1763 57.6962Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5338 49.9375C62.6213 49.9375 64.3136 48.2452 64.3136 46.1577C64.3136 44.0702 62.6213 42.3779 60.5338 42.3779C58.4463 42.3779 56.754 44.0702 56.754 46.1577C56.754 48.2452 58.4463 49.9375 60.5338 49.9375Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M26.1763 57.6962C28.2638 57.6962 29.9561 56.004 29.9561 53.9165C29.9561 51.829 28.2638 50.1367 26.1763 50.1367C24.0888 50.1367 22.3965 51.829 22.3965 53.9165C22.3965 56.004 24.0888 57.6962 26.1763 57.6962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M60.5338 49.9375C62.6213 49.9375 64.3136 48.2452 64.3136 46.1577C64.3136 44.0702 62.6213 42.3779 60.5338 42.3779C58.4463 42.3779 56.754 44.0702 56.754 46.1577C56.754 48.2452 58.4463 49.9375 60.5338 49.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M24.643 40.0541C24.643 40.0541 20.6061 38.9527 19.7279 35.2021C19.7279 35.2021 25.9822 33.9357 26.1617 40.3938L24.643 40.0541Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M25.138 39.6563C25.138 39.6563 22.3189 35.1972 24.7983 31.0293C24.7983 31.0293 29.5533 34.0473 27.4427 39.666L25.138 39.6563Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8852 39.6559C25.8852 39.6559 27.3748 34.9494 31.8775 34.0566C31.8775 34.0566 32.7217 37.1134 28.9662 39.6705L25.8852 39.6559Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9351 39.5488L23.7551 45.1481L28.908 45.1724L29.6649 39.5779L22.9351 39.5488Z",
    fill: "#24285B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_7520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130.691,
    height: 82,
    fill: "white",
    transform: "translate(0.654404)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionMaking);
export default __webpack_public_path__ + "static/media/decision_making.d86cc8c5e67f17af77d6b93fb27b17fc.svg";
export { ForwardRef as ReactComponent };